module.exports = __webpack_public_path__ + "img/SEJ_Eventos_Navbar_Notificaciones.16d0a1c8.svg";